import { Grid } from '@mui/material';

export const Header = ({ value }) => (
  <Grid item className="header" xs={12}>
    <h2>{value}</h2>
  </Grid>
);
